'use client';

import { useState } from "react";
import Link from "next/link";
import { usePathname } from 'next/navigation';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "./ui/button";
import { Menu, X } from "lucide-react";
import Image from "next/image";
  
const siteConfig = {
  name: 'kzoek.com',
};

export default function Header() {
    const [isOpen, setIsOpen] = useState(false);
    const pathname = usePathname();

    const isHondenkapsalonsPath = pathname.startsWith('/hondenkapsalons');
    const isElektriciensPath = pathname.startsWith('/elektriciens');
    
    let blogHref = '/blog';
    if (isHondenkapsalonsPath) blogHref = '/blog?category=Hondenkapsalons';
    if (isElektriciensPath) blogHref = '/blog?category=Elektriciens';

    const navItems = [
      { href: blogHref, label: "Blog" },
      { href: "/over-ons", label: "Over Ons" },
      { href: "/contact", label: "Contact" },
      { href: "/privacy", label: "Privacy & Disclaimer" },
    ];
    
    return (
      <header className="sticky top-0 z-50 w-full border-b border-border/40 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
        <div className="container flex h-14 items-center">
          <Link href="/" className="mr-6 flex items-center space-x-2">
            <Image
                src="/kzoek-transp.png"
                alt="kzoek.com logo"
                width={40}
                height={40}
            />
            <span className="font-bold sm:inline-block">
                {siteConfig.name}
            </span>
          </Link>
          <div className="flex flex-1 items-center justify-end space-x-2">
            <nav className="hidden sm:flex items-center space-x-6 text-sm font-medium">
              {navItems.map((item) => (
                <Link
                  key={item.href}
                  href={item.href}
                  className="transition-colors hover:text-foreground/80 text-foreground/60"
                >
                  {item.label}
                </Link>
              ))}
            </nav>
            <div className="sm:hidden">
              <DropdownMenu open={isOpen} onOpenChange={setIsOpen}>
                <DropdownMenuTrigger asChild>
                  <Button variant="ghost" size="icon">
                    {isOpen ? <X /> : <Menu />}
                  </Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent>
                  {navItems.map((item) => (
                    <DropdownMenuItem key={item.href} asChild>
                      <Link href={item.href}>{item.label}</Link>
                    </DropdownMenuItem>
                  ))}
                </DropdownMenuContent>
              </DropdownMenu>
            </div>
          </div>
        </div>
      </header>
    )
}
